<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="chapter-2">
<h1>Chapter 2</h1>
<p>Art was our favourite class where we could relax enjoy ourselves. It made a welcome escape from other more pressured subjects. Ms Croft was fresh out of university and gave us permission to explore our creativity without constraint.</p>
<p>Yet, for Crystal, Art was an epic fail. She always mucked around and had everyone laughing.</p>
<p>‘Jess, can you draw this for me, <em>please</em>? Otherwise, I’m going to flunk and Mum will be furious.’</p>
<p>‘No can do. Make it abstract,’ I said encouragingly.</p>
<p>‘I’ll pay you,’ she begged.</p>
<p>‘Tempting but bribery will get you nowhere in life.’</p>
<p>‘Pay the right amount and doors open.’ Ash laughed.</p>
<p>‘Soz, Crystal, I’ll get caught and I can’t get into any more trouble,’ I said shaking my head. ‘The principal dislikes me as it is.’</p>
<p>‘Pretty, <em>please</em>,’ she said sounding desperate, ‘with a cherry on top.’</p>
<p>‘No! Challenge yourself, you’ve got this,’ I encouraged her.</p>
<p>‘I’m hopeless but I don’t care. It’s fun and beats French any day,’ Soph added.</p>
<p>Crystal put her head into her hands and groaned loudly.</p>
<p>‘Miss Holland, <em>what</em> is going on?’ asked our art teacher, ‘I’m hearing a lot of laughter.’</p>
<p>‘I suck at art.’</p>
<p>‘Too bad, so sad. Show me what you’ve done.’ Ms Croft leaned over Crystal’s shoulder.</p>
<p>‘A few random lines. I give up,’ said Crystal pushing the paper away.</p>
<p>‘I don’t believe in giving up. Look at Jess’s drawing, see how she allows her imagination to channel in her creativity?’</p>
<p>‘But Jess’s looks amazing,’ whined Crystal.</p>
<p>‘It doesn’t have to be perfect. Less self-criticism and let go. Enjoy the process.’</p>
<p>‘Less chatter and more work,’ mimicked Ashleigh, imitating the principal perfectly. We all laughed understanding exactly what she meant.</p>
<p>‘I’ll help, Ms Croft,’ volunteered Steve, the new guy.</p>
<p>‘Thanks, but no thanks. I can, I will… be a total flop,’ she added quietly.</p>
<p>Crystal was not going to open the door to Steve Malboy or owe him in any way, shape or form.</p>
<p>Steve Malboy had recently moved schools, though we didn’t know why and no one really cared. He was the total package. He’d charm and enchant all the girls in such a way it was as if he’d cast a spell upon them and quickly scored the nickname, “The Magician”.</p>
<p>Steve inherited Mediterranean genes. Made in the image of a Greek God; tall, bronzed, olive eyes, perfect teeth and the longest eyelashes that every girl on the planet envied. He had a discerning habit of running his hands through his gorgeous thick black curls and his voice was deep and appeasing. He oozed confidence and he knew it.</p>
<p>In short, Steve Malboy was a heartbreaker.</p>
<p>And he had his eyes set on Ashleigh, his next victim.</p><br/>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch006.vue?34e0adcb